<template>
    <div>    
      <TabView>					
          <TabPanel header="Arquivo" class="p-mt-3">
              <h6 class="p-text-bold">Período</h6>  
              <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col-12 p-md-3">
                      <label>Dia início</label>
                      <Calendar v-model="dataInicio" :showIcon="true" :touchUI="true" :manualInput="false" dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>				
                  </div>
                  <div class="p-field p-col-12 p-md-3">
                      <label>Dia final</label>
                      <Calendar v-model="dataFinal" :showIcon="true" :touchUI="true" :manualInput="false" dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>	
                  </div>
                  <div class="p-field p-col-12 p-md-3">
                      <label>Layout</label>
                      <Dropdown v-model="tipoProcesso" :options="processos" optionLabel="nome" optionValue="tipo" placeholder="Selecione"/>	
                  </div>
              </div>
              <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col-12 p-md-6">
                      <label>Empresa</label>
                      <Dropdown v-model.number="idCnpjSelecionado" :options="cnpjs" optionLabel="cnpjNome" 
                          optionValue="id" placeholder="Selecione" @change="listarCentrosCustos"/>
                  </div> 
                  <div class="p-field p-col-12 p-md-3">
                      <label>Centro de Custo</label>
                      <Dropdown v-model.number="idCentroCustoSelecionado" :options="centrosCustos" optionLabel="nome" 
                          optionValue="id" placeholder="Todos" :filter="true" :showClear="true"/>
                  </div>                               
              </div>
              <div class="p-fluid p-formgrid p-grid" v-if="this.tipoProcesso == '3'">
                  <div class="p-field p-col-12 p-md-3">
                      <label>Tipo de cálculo para faltas</label>
                      <div class="p-field-radiobutton">
                          <RadioButton id="fixo1" name="fixo" :value="true" v-model="tipoCalculoFalta"/>
                          <label>Dia</label>								
                      </div>
                      <div class="p-field-radiobutton">
                          <RadioButton id="fixo2" name="fixo" :value="false" v-model="tipoCalculoFalta"/>
                          <label>Hora</label>												
                      </div>
                  </div> 
                  <div class="p-field p-col-12 p-md-3">
                      <label>Tipo de cálculo para Dsr</label>
                      <div class="p-field-radiobutton">
                          <RadioButton id="fixo1" name="fixo" :value="true" v-model="tipoCalculoDsr"/>
                          <label>Dia</label>								
                      </div>
                      <div class="p-field-radiobutton">
                          <RadioButton id="fixo2" name="fixo" :value="false" v-model="tipoCalculoDsr"/>
                          <label>Hora</label>												
                      </div>
                  </div>  
              </div>
              <h6 class="p-text-bold">Eventos Selecioinados</h6>  
              <Listbox :options="eventosFolhaSelecionados" optionLabel="descricao" listStyle="max-height:300px" :filter="true"/>
              <Button label="Gerar Arquivo" icon="pi pi-file" class="p-mt-3" @click="exportarArquivoFolha"/>
          </TabPanel>
          <TabPanel header="Eventos" class="p-mt-3">
              <div class="p-formgroup-inline p-mb-3">
                  <Button label="Salvar" class="p-mr-3" icon="pi pi-check" @click="salvar"/>               
              </div>            
              <DataTable :value="eventosFolha" editMode="cell" class="p-datatable-sm p-datatable-striped editable-cells-table">              
                  <Column header="Selecionar" sortable>
                      <template #body="slotProps">
                          <Checkbox v-model="slotProps.data.selecionado" :binary="true" />                      
                      </template>
                  </Column>
                  <Column field="descricao" header="Evento" sortable></Column>
                  <Column field="codigoFolha" header="Código da folha" sortable>
                      <template #editor="slotProps">
                          <InputText type="number" v-model.number="slotProps.data.codigoFolha"/>
                      </template>
                  </Column>
              </DataTable>
          </TabPanel>
      </TabView>
    </div>
  </template>
  
  <script>
  import CentroCustoService from '@/service/CentroCustoService';
  import ArquivoFolhaService from '@/service/ArquivoFolhaService';
  import ArquivoFolhaFacilService from '@/service/ArquivoFolhaFacilService';
  import ArquivoFolhaNasajonService from '@/service/ArquivoFolhaNasajonService';
  import ArquivoFolhaTotvsRMService from '@/service/ArquivoFolhaTotvsRMService';
  import ArquivoFolhaDominioService from '@/service/ArquivoFolhaDominioService';
  import ArquivoFolhaGlobusService from '@/service/ArquivoFolhaGlobusService';
  import CentroCusto from '@/model/CentroCusto';
  import { exibirMensagem, exibirMensagemSis, clonar, localeCalendarBR, download } from '@/global';
  import { mapGetters, mapActions } from 'vuex';
  
  export default {
      arquivoFolhaService: null,
      ArquivoFolhaFacilService: null,
      ArquivoFolhaNasajonService: null,
      ArquivoFolhaTotvsRMService: null,
      centroCustoService: null,
      arquivoFolhaDominioService: null,
      arquivoFolhaGlobusService: null,
      data() {
          return {
              tipoProcesso: '',
              processos: [],
              idCnpjSelecionado: null,
              cnpjs: [],
              idCentroCustoSelecionado: null,            
              centrosCustos: [],            
              eventosFolha: [],
              eventosFolhaSelecionados: [],
              dataInicio: new Date(),
              dataFinal: new Date(),
              tipoCalculoFalta: true,
              tipoCalculoDsr: true,
              filtro: {},
              localeCalendarBR: localeCalendarBR
          }
      },
      methods: {
          ...mapGetters('sessao', ['getDadosRequisicao','getCacheEmpresa']),   
          ...mapActions('sessao', ['atualizarCacheEmpresa']),     
          salvar() {
              let requisicao = {
                  eventosFolha: clonar(this.eventosFolha),
                  usuarioRequisicao: {...this.getDadosRequisicao()}
              }                 
              this.arquivoFolhaService.salvar(requisicao)
              .then(resp => {             
                  exibirMensagem(this, resp);	
                  this.listarEventosFolha();
              })
              .catch(erro => {console.log(erro);exibirMensagem(this, erro)});                        
          },
          listarEventosFolha() {
              let usuarioRequisicao = {...this.getDadosRequisicao()};           
              this.arquivoFolhaService.listar(usuarioRequisicao)
                  .then(resp => {             
                      this.eventosFolhaSelecionados = [];      
                      this.eventosFolha = resp.data;
                      this.eventosFolha.forEach(evento => {
                          if(evento.selecionado) {
                              this.eventosFolhaSelecionados.push(evento);
                          }
                      });
                  })
                  .catch(erro => {console.log(erro);exibirMensagem(this, erro)});
          },
          listarCnpjs() {            
              // Cache dados
              let cacheEmpresa = this.getCacheEmpresa();
              this.cnpjs = cacheEmpresa.cnpjs;
              this.centrosCustos = [];  
              let centroCusto = new CentroCusto();
              centroCusto.nome = 'Todos';
              this.centrosCustos.push(centroCusto);
              Array.prototype.push.apply(this.centrosCustos, [...cacheEmpresa.centrosCustos]);     
              if(cacheEmpresa.idCnpjSelecionado) {
                  this.idCnpjSelecionado = cacheEmpresa.idCnpjSelecionado;
              }
          },
          listarCentrosCustos() {
              let cacheEmpresa = this.getCacheEmpresa();
              cacheEmpresa.idCnpjSelecionado = this.idCnpjSelecionado; 
              this.idsCentrosCustos = [];
              let requisicao = {
                  idCnpj: this.idCnpjSelecionado,
                  usuarioRequisicao: {...this.getDadosRequisicao()}
              };
              this.centroCustoService.listarCentrosCustosUsuario(requisicao)
              .then(resp => {   
                  // Cache dados      
                  cacheEmpresa.centrosCustos = [];              
                  resp.data.forEach(ct => {
                      cacheEmpresa.centrosCustos.push({...ct});
                  }); 
                  this.idCentroCustoSelecionado = 0;                     
                  this.centrosCustos = []; 
                  let centroCusto = new CentroCusto();
                  centroCusto.id = 0;
                  centroCusto.nome = 'Todos';
                  this.centrosCustos.push(centroCusto);
                  Array.prototype.push.apply(this.centrosCustos, resp.data);
                  this.atualizarCacheEmpresa(cacheEmpresa); 
              })
              .catch(erro => {exibirMensagem(this, erro)});
          },
          exportarArquivoFolha() {
              if(this.tipoProcesso == null || this.tipoProcesso == '') {
                  exibirMensagemSis(this, 'Selecione um layout', true);
                  return;
              }
              if(this.idCnpjSelecionado == null) {
                  exibirMensagemSis(this, 'Selecione uma empresa', true);
                  return;
              }           
              let cnpj = null;
              for(let i = 0; i < this.cnpjs.length; i++) {
                  if(this.idCnpjSelecionado == this.cnpjs[i].id) {
                      cnpj = this.cnpjs[i];
                      break;
                  }
              }   
              let idsCentrosCustos = []; 
              if(this.idCentroCustoSelecionado == null || this.idCentroCustoSelecionado == 0) {
                  this.centrosCustos.forEach(ct => {
                      if(ct.id != null) {
                          idsCentrosCustos.push(ct.id);
                      }
                  });
              } else {
                  idsCentrosCustos.push(this.idCentroCustoSelecionado);
                  this.filtrarCentosCustosFilhos(this.idCentroCustoSelecionado, this.centrosCustos, idsCentrosCustos);
              }        
              let requisicao = {      
                  eventosFolha: clonar(this.eventosFolhaSelecionados),
                  tipoProcesso: this.tipoProcesso,         
                  dataInicio: this.formatarData(this.dataInicio),
                  dataFinal: this.formatarData(this.dataFinal),
                  cnpj: {...cnpj},
                  idsCentrosCustos: idsCentrosCustos,
                  tipoCalculoFalta: this.tipoCalculoFalta,
                  tipoCalculoDsr: this.tipoCalculoDsr,
                  usuarioRequisicao: {...this.getDadosRequisicao()}                
              };     
              if(this.tipoProcesso == '1') {
                  this.arquivoFolhaService.exportarArquivoFolha(requisicao)
                  .then(resp => {     
                      download(resp.data, resp.headers['ik-response']);            
                  })
                  .catch(erro => {
                      if(erro.response.headers['ik-response']) {
                          erro.response.data = JSON.parse(erro.response.headers['ik-response']);
                      }
                      exibirMensagem(this, erro)
                  });  
              }
              if(this.tipoProcesso == '2') {
                  this.arquivoFolhaService.exportarArquivoFolha(requisicao)
                  .then(resp => {     
                      download(resp.data, resp.headers['ik-response']);            
                  })
                  .catch(erro => {
                      if(erro.response.headers['ik-response']) {
                          erro.response.data = JSON.parse(erro.response.headers['ik-response']);
                      }
                      exibirMensagem(this, erro)
                  });
              }
              if(this.tipoProcesso == '3') {
                  this.ArquivoFolhaDominioService.exportarArquivoFolha(requisicao)
                  .then(resp => {     
                      download(resp.data, resp.headers['ik-response']);            
                  })
                  .catch(erro => {
                      if(erro.response.headers['ik-response']) {
                          erro.response.data = JSON.parse(erro.response.headers['ik-response']);
                      }
                      exibirMensagem(this, erro)
                  });
              }
              if(this.tipoProcesso == '4') {
                  this.ArquivoFolhaFacilService.exportarArquivoFolha(requisicao)
                  .then(resp => {     
                      download(resp.data, resp.headers['ik-response']);            
                  })
                  .catch(erro => {
                      if(erro.response.headers['ik-response']) {
                          erro.response.data = JSON.parse(erro.response.headers['ik-response']);
                      }
                      exibirMensagem(this, erro)
                  }); 
              } 
              if(this.tipoProcesso == '5') {
                  this.ArquivoFolhaNasajonService.exportarArquivoFolha(requisicao)
                  .then(resp => {     
                      download(resp.data, resp.headers['ik-response']);            
                  })
                  .catch(erro => {
                      if(erro.response.headers['ik-response']) {
                          erro.response.data = JSON.parse(erro.response.headers['ik-response']);
                      }
                      exibirMensagem(this, erro)
                  });  
              }
              if(this.tipoProcesso == '6') {
                  this.ArquivoFolhaTotvsRMService.exportarArquivoFolha(requisicao)
                  .then(resp => {     
                      download(resp.data, resp.headers['ik-response']);            
                  })
                  .catch(erro => {
                      if(erro.response.headers['ik-response']) {
                          erro.response.data = JSON.parse(erro.response.headers['ik-response']);
                      }
                      exibirMensagem(this, erro)
                  });
              }
              if(this.tipoProcesso == '7') {
                  this.arquivoFolhaGlobusService.exportarArquivoFolha(requisicao)
                  .then(resp => {     
                      download(resp.data, resp.headers['ik-response']);            
                  })
                  .catch(erro => {
                      if(erro.response.headers['ik-response']) {
                          erro.response.data = JSON.parse(erro.response.headers['ik-response']);
                      }
                      exibirMensagem(this, erro)
                  });
              }          
          },
          filtrarCentosCustosFilhos(idCentroCustoPrincipal, centrosCustos, idsCentrosCustos) {
              centrosCustos.forEach(ct => {
                  if(ct.id != null 
                      && ct.centroCustoPaiId
                      && ct.centroCustoPaiId == idCentroCustoPrincipal) {
                      idsCentrosCustos.push(ct.id);
                      this.filtrarCentosCustosFilhos(ct.id, centrosCustos, idsCentrosCustos);
                  }
              }); 
          },
          carregarProcessos() {
              this.processos.push({nome: "AlterData", tipo:"1"});	
              this.processos.push({nome: "AlterData GBL", tipo:"2"});	
              this.processos.push({nome: "Globus", tipo:"7"});	
              this.processos.push({nome: "Dominio", tipo:"3"});	
              this.processos.push({nome: "Folha Fácil", tipo:"4"});
              this.processos.push({nome: "NasaJon", tipo:"5"});	
              this.processos.push({nome: "Totvs RM", tipo:"6"});			
          },
          formatarData(data) {
              if(!data) {
                  return null;
              }
              let strData = null;
              if(data instanceof Date) {
                  let dt = data;
                  let mes = dt.getMonth();
                  let dia = dt.getDate();
                  strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
              } else {
                  let partes = data.split('/');
                  strData = partes[2] + '-' + partes[1] + '-' + partes[0];
              }
              return strData;
          }
      },
      created() {
          this.centroCustoService = new CentroCustoService();
          this.arquivoFolhaService = new ArquivoFolhaService();
          this.ArquivoFolhaFacilService = new ArquivoFolhaFacilService();
          this.ArquivoFolhaNasajonService = new ArquivoFolhaNasajonService();
          this.ArquivoFolhaTotvsRMService = new ArquivoFolhaTotvsRMService();
          this.ArquivoFolhaDominioService = new ArquivoFolhaDominioService();
          this.arquivoFolhaGlobusService = new ArquivoFolhaGlobusService();
      },
      mounted() {
          this.listarEventosFolha();
          this.listarCnpjs();
          this.carregarProcessos();
      }
  }
  </script>
  
  <style>
  
  </style>